<template>
  <v-flex v-bind="$attrs">
    <v-card>
      <v-layout column>
        <v-flex>
          <Toolbar
            :title="title"
            :shouldShowSearch="shouldShowSearch"
            :actions="toolbarActions"
            :isPrimary="isPrimary"
            @onClicked="(val) => $emit('onClicked', val)"
            :icon="icon"
            :breadCrumbs="breadCrumbs"
            @onClickBreadcrumb="(val) => $emit('onClickBreadcrumb', val)"
            :isLoading="isPrimary && isLoading"
            @onShouldSearch="(val) => $emit('onShouldSearch', val)"
          >
            <template v-slot:toolbarExtension>
              <slot name="toolbarExtension" />
            </template>
          </Toolbar>
        </v-flex>
        <v-flex>
          <slot />
        </v-flex>
      </v-layout>
    </v-card>
  </v-flex>
</template>

<script>
import Toolbar from './Toolbar'

export default {
  inheritAttrs: false,
  components: {
    Toolbar,
  },
  props: {
    shouldShowSearch: {
      type: Boolean,
      default: false,
    },
    isLoading: Boolean,
    breadCrumbs: Array,
    title: String,
    icon: String,
    isPrimary: {
      type: Boolean,
      default: true,
    },
    toolbarActions: {
      model: Array,
      validator: (val) => {
        return val.every((action) => action.hasOwnProperty('emitEvent'))
      },
    },
  },
  data: () => ({}),
  methods: {},
}
</script>
